import UserActivity from "components/modules/SecurebootActivity/UserActivity";

const SecurebootActivityPage = () => {
  return <UserActivity />;
};

export default SecurebootActivityPage;
